import { FormsData, SubFormsDataTypes } from "../../models/forms";
import { ProgramsDataResponse } from "../../server/crm/api/models/forms";
import { OnboardingRootState } from "../reducers/rootReducer";
import { getGameConceptPageState } from "./gameConceptPageSelectors";
import { getOnboardingState } from "./rootSelectors";
import { getCurrentProgram } from "./statusSelectors";

export const getCurrentProgramData = (state: OnboardingRootState): ProgramsDataResponse =>
  getOnboardingState(state).programs[getCurrentProgram(state)];

export const getFormData = (state: OnboardingRootState, formId: string): FormsData => {
  const programData = getCurrentProgramData(state);
  return programData?.forms?.[formId];
};

export const getSubFormData = (
  state: OnboardingRootState,
  formId: string,
  subFormId: string
): SubFormsDataTypes => {
  const form = getFormData(state, formId);
  const programValue = form?.subForms[subFormId];
  if (programValue !== undefined) {
    return programValue;
  }
  // Fall back to gameConceptPage data when programs state hasn't been populated yet
  const gameConceptData = getGameConceptPageState(state).data;
  return (gameConceptData?.formData as Record<string, SubFormsDataTypes>)?.[subFormId] ?? undefined;
};
